import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { DataTable } from '@/v2/components/DataTable/tasks/components/data-table';
import { DataTableColumnHeader } from '@/v2/components/DataTable/tasks/components/data-table-column-header';
import { format } from 'date-fns';
import useFetch from 'use-http';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  useUserDispatch,
  useUserState,
} from '@/components/context/UserContext';
import { getQueryString } from '@/components/constants/visitsQueryStringBuilder';
import { InfoButton } from '@/components/ui/shared/InfoButton';

export default function ReferralsTable() {
  const { t } = useTranslation();
  const history = useHistory();
  const sessionDispatch = useUserDispatch();
  const userState = useUserState();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [dateRange, setDateRange] = useState(userState.dateFilter);

  const { get: getReferrals, response: referralsResponse } = useFetch(
    '/UserAccount/ReferralsList',
  );
  const { get: getReferral } = useFetch('/UserAccount/Referral');

  const fetchData = async (date = dateRange, searchTerm = search) => {
    setIsLoading(true);
    sessionDispatch({
      type: 'UPDATE',
      data: { dateFilter: date },
    });

    const query = getQueryString(
      date,
      searchTerm,
      undefined,
      undefined,
      userState.espbiEsi,
    );
    const result = await getReferrals(query);

    if (referralsResponse.ok) {
      const sorted = _.orderBy(result, ['occurrenceDateTime'], ['desc']);
      setData(sorted);
    }
    setIsLoading(false);
  };

  const handleSelection = async (id) => {
    setIsLoading(true);
    const query = userState.espbiEsi
      ? `?id=${id}&espbiEsi=${userState.espbiEsi}`
      : `?id=${id}`;

    const res = await getReferral(query);
    history.push('/userAccount/referrals/details', { data: res });
  };

  useEffect(() => {
    fetchData();
  }, [dateRange, userState?.espbiEsi]);

  return (
    <DataTable
      title="Siuntimai"
      loading={isLoading}
      columns={columns({ handleSelection })}
      data={data}
      filterableColumns={['specialty', 'occurrenceDateTime']}
      onRowClick={(row) => handleSelection(row.id)}
    />
  );
}

const columns = ({ handleSelection }) => [
  {
    accessorKey: 'specialty',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="SPECIALISTAS" />
    ),
    cell: ({ row }) => (
      <span className="font-medium max-w-[400px] truncate capitalize">
        {row.original.specialty}
      </span>
    ),
  },
  {
    accessorKey: 'occurrenceDateTime',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="DATA" />
    ),
    cell: ({ row }) => {
      const rawDate = new Date(row.original.occurrenceDateTime);
      const isMidnight =
        rawDate.getUTCHours() === 0 && rawDate.getUTCMinutes() === 0;
      return (
        <span className="text-muted-foreground">
          {isMidnight
            ? format(rawDate, 'yyyy-MM-dd')
            : format(rawDate, 'yyyy-MM-dd HH:mm')}
        </span>
      );
    },
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <InfoButton
          onClick={(e) => {
            e.stopPropagation();
            handleSelection(row.original.id);
          }}
        >
          Informacija
        </InfoButton>
      </div>
    ),
  },
];
